// extracted by mini-css-extract-plugin
var _1 = "SessionResume_actions__02c4b";
var _2 = "SessionResume_cardContainer__2bf28";
var _3 = "SessionResume_cardWrapper__12217";
var _4 = "SessionResume_description__930f1";
var _5 = "SessionResume_detailLabel__966fe";
var _6 = "SessionResume_detailRow__a1f99";
var _7 = "SessionResume_detailValue__6d334";
var _8 = "SessionResume_header__2a79c";
var _9 = "SessionResume_root__ed7ba";
var _a = "SessionResume_sessionDetails__a9867";
var _b = "SessionResume_title__257d7";
export { _1 as "actions", _2 as "cardContainer", _3 as "cardWrapper", _4 as "description", _5 as "detailLabel", _6 as "detailRow", _7 as "detailValue", _8 as "header", _9 as "root", _a as "sessionDetails", _b as "title" }
